import {EntityStateAdapter} from '@/store/base.store';
import {TeamModel} from '@/models/team.model';
import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {shareReplay, take} from 'rxjs/operators';
import {UserTeamsApi} from '@/api/user-teams.api';

export const featureKey = 'user_teams';

// @ts-ignore
if (store.state.user_teams) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class UserTeamsStoreModule extends EntityStateAdapter<TeamModel> {

  get total(): number {
    return super.total;
  }

  get loading(): boolean {
    return super.loading;
  }

  get entities(): TeamModel[] {
    return super.entities;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  @Action({commit: 'upsertMany', rawError: true})
  async fetchUserTeams(data: { page: number, userSlug: string }): Promise<TeamModel[]> {
    if (!!this.entities && this.entities.length > 0 && data.page !== this.currentPage) {
      return this._entities;
    }
    this.context.commit('loadingUpdated', true);
    const response = await (new UserTeamsApi())
      .fetchMyTeams(data.userSlug, {page: data.page})
      .pipe(take(1), shareReplay()).toPromise();

    this.context.commit('updateAllPageParams', response);
    this.context.commit('loadingUpdated', false);
    return response.data
  }
}
